/* === DIGITAL STUDIO THEME — theme.js === */
"use strict";

// ── Crossfade Slideshow ────────────────────────────────────
// All slides are stacked via CSS position:absolute.
// Transitioning means fading OUT the current, fading IN the next.

function changeSlide(id, dir) {
  const sw = document.getElementById(id);
  if (!sw) return;
  const slides = sw.querySelectorAll(".slide");
  const dots   = sw.querySelectorAll(".slide-dot");
  let cur = [...slides].findIndex(s => s.classList.contains("active"));
  const next = (cur + dir + slides.length) % slides.length;
  crossfadeTo(slides, dots, cur, next);
}

function goToSlide(id, idx) {
  const sw = document.getElementById(id);
  if (!sw) return;
  const slides = sw.querySelectorAll(".slide");
  const dots   = sw.querySelectorAll(".slide-dot");
  const cur = [...slides].findIndex(s => s.classList.contains("active"));
  if (cur === idx) return;
  crossfadeTo(slides, dots, cur, idx);
}

function crossfadeTo(slides, dots, from, to) {
  if (from === to) return;
  // Bring next slide in behind current (visible but opacity 0)
  slides[to].classList.add("active", "entering");
  // After a tick, fade out current — CSS handles the opacity transition
  requestAnimationFrame(() => {
    slides[from].classList.add("leaving");
    slides[to].classList.remove("entering");
  });
  // After transition completes, clean up classes
  setTimeout(() => {
    slides[from].classList.remove("active", "leaving");
    dots.forEach((d,i) => d.classList.toggle("active", i === to));
  }, 1100); // slightly longer than CSS transition
}

window.changeSlide = changeSlide;
window.goToSlide   = goToSlide;

// Auto-advance every 5s
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".slideshow[data-auto]").forEach(sw => {
    const interval = parseInt(sw.dataset.auto) || 5000;
    setInterval(() => changeSlide(sw.id, 1), interval);
  });
});
